/**
 * System Admin Bundle Configuration
 * Routes accessible to SYSTEM_ADMIN role only
 */

// Routes only a SYSTEM_ADMIN can open. Must be kept in sync with
// pageLoader.bundle.system-admin.js (which controls which page chunks
// actually live in this bundle) and jwt-validator.ts (which blocks
// non-SYSTEM_ADMIN requests for /assets/system-admin/* at the edge).
export const SYSTEM_ADMIN_ROUTES = [
    'admin',
    'customers',
    // METALARK-929: reseller/agency partner management (SYSTEM_ADMIN-only).
    'partners',
    'customer-360',
    'customer-deletions',
    // New-customer wizard (METALARK-671) — stepped provisioning flow that
    // replaces the old modal. Backed by POST /admin/customers/provision.
    'new-customer',
    // Subscription metrics dashboard (METALARK-671) — revenue, conversion,
    // churn, plan mix, and account health. Backed by GET /admin/metrics.
    'metrics',
    'custom-domains',
    'audit-logs',
    'feature-flags',
    // Processing X-Ray (METALARK-1190) — job-tree trace for an upload, a migration push
    // or a scheduled run. The page chunk was already registered in
    // pageLoader.bundle.system-admin.js but the route was never added here, which is the
    // desync this file's header warns about: getBundleForRoute('xray') returned undefined,
    // so the bundle was never preloaded and every render logged
    // "[BundleLoader] No bundle mapping found for route: xray". The page still worked, by
    // falling back to a full component scan that also warned each time.
    'xray',
    // Global cross-customer users list — SYSTEM_ADMIN only. Customer-scoped
    // user management lives in Customer 360's Users tab.
    'users',
    // Email templates are shared/system-wide content — SYSTEM_ADMIN only.
    'email-templates',
    'email-suppression-list',
    'notification-dashboard',
    'quota-health',
    'activity-dashboard',
    // Outbound webhook delivery log (METALARK-271) — read-only operational view
    // of every Google Chat / future-Slack / future-customer-webhook attempt the
    // lifecycle bus has fired. SYSTEM_ADMIN only; backed by GET /webhookdeliveries.
    'webhook-deliveries',
    // Webhook subscription + rule configuration (METALARK-271) — destinations
    // and event-routing rules for the lifecycle bus. SYSTEM_ADMIN only here;
    // the customer-scoped admin view will live in Customer 360 → Webhooks
    // when customer-facing webhooks land.
    'webhook-subscriptions',
    'campaigns',
    'repository-providers-setup',
    'stripe-setup',
] as const;

export type SystemAdminRoute = typeof SYSTEM_ADMIN_ROUTES[number];

export const SYSTEM_ADMIN_BUNDLE_PATH = '/assets/system-admin';
export const BUNDLE_NAME = 'system-admin';
export const REQUIRED_ROLES = ['SYSTEM_ADMIN'];
